module.exports = __webpack_public_path__ + "img/Supply.d3aa55a7.png";